import script from "./MerchantData.vue?vue&type=script&lang=ts&setup=true&name=memberList"
export * from "./MerchantData.vue?vue&type=script&lang=ts&setup=true&name=memberList"

import "./MerchantData.vue?vue&type=style&index=0&id=b04a17ae&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b04a17ae"]])

export default __exports__